"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DesignSourceEnum;
(function (DesignSourceEnum) {
    DesignSourceEnum["clipboard"] = "clipboard";
    DesignSourceEnum["designSearch"] = "design_search";
    DesignSourceEnum["email"] = "email";
    DesignSourceEnum["enterCode"] = "enter_code";
    DesignSourceEnum["gallery"] = "gallery";
    DesignSourceEnum["imageDeeplink"] = "image_deeplink";
    DesignSourceEnum["iSell"] = "i_sell";
    DesignSourceEnum["planningSupportTool"] = "planning_support_tool";
    DesignSourceEnum["qr"] = "qr";
    DesignSourceEnum["recommendation"] = "recommendation";
    DesignSourceEnum["resumeLastDesign"] = "resume_last_design";
    DesignSourceEnum["retailerSystem"] = "retailer_system";
    DesignSourceEnum["salesSystem"] = "sales_system";
    DesignSourceEnum["searchBar"] = "search_bar";
    DesignSourceEnum["skytta"] = "skytta";
    DesignSourceEnum["sms"] = "sms";
    DesignSourceEnum["space"] = "space";
    DesignSourceEnum["spr"] = "spr";
    DesignSourceEnum["profile"] = "profile";
    DesignSourceEnum["storageGuide"] = "storage_guide";
    DesignSourceEnum["startFromSaved"] = "start_from_saved";
    DesignSourceEnum["startFromScratch"] = "start_from_scratch";
    DesignSourceEnum["startFromTemplate"] = "start_from_template";
    DesignSourceEnum["unknown"] = "unknown";
})(DesignSourceEnum || (DesignSourceEnum = {}));
exports.default = DesignSourceEnum;
//# sourceMappingURL=DesignSourceEnum.js.map